export function getMaxWidth() {
  return window.innerWidth || document.documentElement.clientWidth;
}
